import { render, staticRenderFns } from "./infoCode.vue?vue&type=template&id=552d6f4a&scoped=true&"
import script from "./infoCode.vue?vue&type=script&lang=js&"
export * from "./infoCode.vue?vue&type=script&lang=js&"
import style0 from "./infoCode.vue?vue&type=style&index=0&id=552d6f4a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552d6f4a",
  null
  
)

export default component.exports